import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import AccountMenu from './AccountMenu'
import { loadUserInfo as loadUserInfoConnect } from '../actions/account'
import { setDialog as setDialogConnect } from '../actions/navigation'

const Account = ({ loggedIn, setDialog, loadUserInfo }) => {
    const [showAccountMenu, setShowAccountMenu] = useState(false)

    useEffect(() => {
        loadUserInfo()
    }, [])

    if (!loggedIn) {
        return (
            <>
                <li>
                    <button type="button" className="account-nav-button" onClick={() => setDialog('signIn')}>
                        Sign In
                    </button>
                </li>
                <li>
                    <button type="button" className="account-nav-button" onClick={() => setDialog('createAccount')}>
                        Sign Up
                    </button>
                </li>
            </>
        )
    }

    // else
    return (
        <>
            <li>
                <button
                    type="button"
                    className="account-nav-button"
                    onClick={() => {
                        setShowAccountMenu(!showAccountMenu)
                    }}
                >
                    My Account
                </button>
                <AccountMenu
                    showMenu={showAccountMenu}
                    hideMenu={() => {
                        setShowAccountMenu(false)
                    }}
                />
            </li>
        </>
    )
}

Account.propTypes = {
    loggedIn: PropTypes.bool.isRequired,
    loadUserInfo: PropTypes.func.isRequired,
    setDialog: PropTypes.func.isRequired
}

export default connect(
    ({ account: { email } }) => ({ loggedIn: !!email }),
    dispatch => ({
        loadUserInfo: () => dispatch(loadUserInfoConnect()),
        setDialog: dialogName => dispatch(setDialogConnect(dialogName))
    })
)(Account)
